module.exports = __webpack_public_path__ + "static/tourmaline-11e1edd404f96ffae6adfed06187006c.svg";